import {
  mapGetters,
  mapMutations,
} from 'vuex';

import _ from 'lodash';

export default {
  name: 'TireSizeSelectorItem',
  components: {},
  props: {
    tireCodes: {},
    tireLocation: '',
    tireSizeState: {},
  },
  data: () => ({}),
  computed: {
    initialTireCode() {
      const tireType = this.tireType !== 'ms' ? 'TZ' : 'MS';
      return `${tireType}_${this.runFlat ? '1' : '0'}`;
    },
    requiredImageUrl() {
      return require(
        `@/assets/images/car-types/${this.bodyworkType}-${this.tireLocation.replace('Tire', '')}.png`,
      );
    },
    ...mapGetters('appointment', {
      bodyworkType: 'getBodyworkType',
      tireType: 'getTireType',
      runFlat: 'getRunFlat',
    }),
    tireSize() {
      return _.cloneDeep(this.$props.tireSizeState);
    },
    // Dropdowns
    widths() {
      const widthsOfCurrentTireCode = this.tireCodes.find(tc => tc.key === this.initialTireCode);
      return widthsOfCurrentTireCode != null ? widthsOfCurrentTireCode.value.split('|') : [];
    },
    heights() {
      const tireCode = `${this.initialTireCode}_${this.$props.tireSizeState.width}`;
      const heightsOfCurrentTireCode = this.tireCodes.find(tc => tc.key === tireCode);
      return heightsOfCurrentTireCode != null ? heightsOfCurrentTireCode.value.split('|') : [];
    },
    diameters() {
      const tireCode =
        `${this.initialTireCode}_${this.$props.tireSizeState.width}_${this.$props.tireSizeState.height}`;
      const diametersOfCurrentTireCode = this.tireCodes.find(tc => tc.key === tireCode);
      return diametersOfCurrentTireCode != null ? diametersOfCurrentTireCode.value.split('|') : [];
    },
    loadCapacities() {
      const tireCode =
        `${this.initialTireCode}_${this.$props.tireSizeState.width}_${this.$props.tireSizeState.height}_${this.$props.tireSizeState.diameter}`;
      const loadCapacitiesOfCurrentTireCode = this.tireCodes.find(tc => tc.key === tireCode);
      return loadCapacitiesOfCurrentTireCode != null ?
        loadCapacitiesOfCurrentTireCode.value.split('|') : [];
    },
    speedIndexes() {
      const tireCode =
        `${this.initialTireCode}_${this.$props.tireSizeState.width}_${this.$props.tireSizeState.height}_${this.$props.tireSizeState.diameter}_${this.$props.tireSizeState.loadCapacity}`;
      const speedIndexesOfCurrentTireCode = this.tireCodes.find(tc => tc.key === tireCode);
      return speedIndexesOfCurrentTireCode != null ?
        speedIndexesOfCurrentTireCode.value.split('|') : [];
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setTireSizeMutation: 'SET_TIRESIZE',
    }),
    updateTireSize() {
      const changeTireSizeStateObject = {
        property: this.tireLocation,
        size: this.tireSize,
      };

      this.setTireSizeMutation(changeTireSizeStateObject);
    },
  },
};
